import { default as indexP78MI2jY0hMeta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/[roundId]/index.vue?macro=true";
import { default as results3vBrpW0ADcMeta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/[roundId]/results.vue?macro=true";
import { default as indexFL7eOwEUO3Meta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/index.vue?macro=true";
import { default as noneT3j5BKruVCMeta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/none.vue?macro=true";
import { default as profilenuCh5rk6YVMeta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/profile.vue?macro=true";
import { default as image6QgcEPZ3JyMeta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/admin/answer/[answerId]/image.vue?macro=true";
import { default as indexi2eBB2yaB7Meta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/admin/index.vue?macro=true";
import { default as aggregategwzXh4m6deMeta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/aggregate.vue?macro=true";
import { default as index0stiue8G9jMeta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/index.vue?macro=true";
import { default as profileal7ud3IryLMeta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/profile.vue?macro=true";
import { default as resultsKLBisWWskGMeta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/results.vue?macro=true";
import { default as _91roundId_93ybsjBIdtELMeta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/round/[roundId].vue?macro=true";
import { default as createrbaGHcl6MVMeta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/round/create.vue?macro=true";
import { default as _91userId_9302iBLFUqudMeta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/users/[userId].vue?macro=true";
import { default as indexmkn98puJ23Meta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/users/index.vue?macro=true";
import { default as createMrEiG166E8Meta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/create.vue?macro=true";
import { default as indexXYhPSjsEQoMeta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/index.vue?macro=true";
import { default as loginoWvDcAgGkjMeta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/login.vue?macro=true";
import { default as registerEgeCKsRer8Meta } from "/codebuild/output/src3411422935/src/sense-us.app/pages/register.vue?macro=true";
export default [
  {
    name: indexP78MI2jY0hMeta?.name ?? "projectId-roundId___en",
    path: indexP78MI2jY0hMeta?.path ?? "/:projectId()/:roundId()",
    meta: indexP78MI2jY0hMeta || {},
    alias: indexP78MI2jY0hMeta?.alias || [],
    redirect: indexP78MI2jY0hMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/[roundId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexP78MI2jY0hMeta?.name ?? "projectId-roundId___nl",
    path: indexP78MI2jY0hMeta?.path ?? "/nl/:projectId()/:roundId()",
    meta: indexP78MI2jY0hMeta || {},
    alias: indexP78MI2jY0hMeta?.alias || [],
    redirect: indexP78MI2jY0hMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/[roundId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexP78MI2jY0hMeta?.name ?? "projectId-roundId___de",
    path: indexP78MI2jY0hMeta?.path ?? "/de/:projectId()/:roundId()",
    meta: indexP78MI2jY0hMeta || {},
    alias: indexP78MI2jY0hMeta?.alias || [],
    redirect: indexP78MI2jY0hMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/[roundId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexP78MI2jY0hMeta?.name ?? "projectId-roundId___es",
    path: indexP78MI2jY0hMeta?.path ?? "/es/:projectId()/:roundId()",
    meta: indexP78MI2jY0hMeta || {},
    alias: indexP78MI2jY0hMeta?.alias || [],
    redirect: indexP78MI2jY0hMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/[roundId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexP78MI2jY0hMeta?.name ?? "projectId-roundId___fr",
    path: indexP78MI2jY0hMeta?.path ?? "/fr/:projectId()/:roundId()",
    meta: indexP78MI2jY0hMeta || {},
    alias: indexP78MI2jY0hMeta?.alias || [],
    redirect: indexP78MI2jY0hMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/[roundId]/index.vue").then(m => m.default || m)
  },
  {
    name: results3vBrpW0ADcMeta?.name ?? "projectId-roundId-results___en",
    path: results3vBrpW0ADcMeta?.path ?? "/:projectId()/:roundId()/results",
    meta: results3vBrpW0ADcMeta || {},
    alias: results3vBrpW0ADcMeta?.alias || [],
    redirect: results3vBrpW0ADcMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/[roundId]/results.vue").then(m => m.default || m)
  },
  {
    name: results3vBrpW0ADcMeta?.name ?? "projectId-roundId-results___nl",
    path: results3vBrpW0ADcMeta?.path ?? "/nl/:projectId()/:roundId()/results",
    meta: results3vBrpW0ADcMeta || {},
    alias: results3vBrpW0ADcMeta?.alias || [],
    redirect: results3vBrpW0ADcMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/[roundId]/results.vue").then(m => m.default || m)
  },
  {
    name: results3vBrpW0ADcMeta?.name ?? "projectId-roundId-results___de",
    path: results3vBrpW0ADcMeta?.path ?? "/de/:projectId()/:roundId()/results",
    meta: results3vBrpW0ADcMeta || {},
    alias: results3vBrpW0ADcMeta?.alias || [],
    redirect: results3vBrpW0ADcMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/[roundId]/results.vue").then(m => m.default || m)
  },
  {
    name: results3vBrpW0ADcMeta?.name ?? "projectId-roundId-results___es",
    path: results3vBrpW0ADcMeta?.path ?? "/es/:projectId()/:roundId()/results",
    meta: results3vBrpW0ADcMeta || {},
    alias: results3vBrpW0ADcMeta?.alias || [],
    redirect: results3vBrpW0ADcMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/[roundId]/results.vue").then(m => m.default || m)
  },
  {
    name: results3vBrpW0ADcMeta?.name ?? "projectId-roundId-results___fr",
    path: results3vBrpW0ADcMeta?.path ?? "/fr/:projectId()/:roundId()/results",
    meta: results3vBrpW0ADcMeta || {},
    alias: results3vBrpW0ADcMeta?.alias || [],
    redirect: results3vBrpW0ADcMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/[roundId]/results.vue").then(m => m.default || m)
  },
  {
    name: indexFL7eOwEUO3Meta?.name ?? "projectId___en",
    path: indexFL7eOwEUO3Meta?.path ?? "/:projectId()",
    meta: indexFL7eOwEUO3Meta || {},
    alias: indexFL7eOwEUO3Meta?.alias || [],
    redirect: indexFL7eOwEUO3Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexFL7eOwEUO3Meta?.name ?? "projectId___nl",
    path: indexFL7eOwEUO3Meta?.path ?? "/nl/:projectId()",
    meta: indexFL7eOwEUO3Meta || {},
    alias: indexFL7eOwEUO3Meta?.alias || [],
    redirect: indexFL7eOwEUO3Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexFL7eOwEUO3Meta?.name ?? "projectId___de",
    path: indexFL7eOwEUO3Meta?.path ?? "/de/:projectId()",
    meta: indexFL7eOwEUO3Meta || {},
    alias: indexFL7eOwEUO3Meta?.alias || [],
    redirect: indexFL7eOwEUO3Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexFL7eOwEUO3Meta?.name ?? "projectId___es",
    path: indexFL7eOwEUO3Meta?.path ?? "/es/:projectId()",
    meta: indexFL7eOwEUO3Meta || {},
    alias: indexFL7eOwEUO3Meta?.alias || [],
    redirect: indexFL7eOwEUO3Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexFL7eOwEUO3Meta?.name ?? "projectId___fr",
    path: indexFL7eOwEUO3Meta?.path ?? "/fr/:projectId()",
    meta: indexFL7eOwEUO3Meta || {},
    alias: indexFL7eOwEUO3Meta?.alias || [],
    redirect: indexFL7eOwEUO3Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: noneT3j5BKruVCMeta?.name ?? "projectId-none___en",
    path: noneT3j5BKruVCMeta?.path ?? "/:projectId()/none",
    meta: noneT3j5BKruVCMeta || {},
    alias: noneT3j5BKruVCMeta?.alias || [],
    redirect: noneT3j5BKruVCMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/none.vue").then(m => m.default || m)
  },
  {
    name: noneT3j5BKruVCMeta?.name ?? "projectId-none___nl",
    path: noneT3j5BKruVCMeta?.path ?? "/nl/:projectId()/none",
    meta: noneT3j5BKruVCMeta || {},
    alias: noneT3j5BKruVCMeta?.alias || [],
    redirect: noneT3j5BKruVCMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/none.vue").then(m => m.default || m)
  },
  {
    name: noneT3j5BKruVCMeta?.name ?? "projectId-none___de",
    path: noneT3j5BKruVCMeta?.path ?? "/de/:projectId()/none",
    meta: noneT3j5BKruVCMeta || {},
    alias: noneT3j5BKruVCMeta?.alias || [],
    redirect: noneT3j5BKruVCMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/none.vue").then(m => m.default || m)
  },
  {
    name: noneT3j5BKruVCMeta?.name ?? "projectId-none___es",
    path: noneT3j5BKruVCMeta?.path ?? "/es/:projectId()/none",
    meta: noneT3j5BKruVCMeta || {},
    alias: noneT3j5BKruVCMeta?.alias || [],
    redirect: noneT3j5BKruVCMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/none.vue").then(m => m.default || m)
  },
  {
    name: noneT3j5BKruVCMeta?.name ?? "projectId-none___fr",
    path: noneT3j5BKruVCMeta?.path ?? "/fr/:projectId()/none",
    meta: noneT3j5BKruVCMeta || {},
    alias: noneT3j5BKruVCMeta?.alias || [],
    redirect: noneT3j5BKruVCMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/none.vue").then(m => m.default || m)
  },
  {
    name: profilenuCh5rk6YVMeta?.name ?? "projectId-profile___en",
    path: profilenuCh5rk6YVMeta?.path ?? "/:projectId()/profile",
    meta: profilenuCh5rk6YVMeta || {},
    alias: profilenuCh5rk6YVMeta?.alias || [],
    redirect: profilenuCh5rk6YVMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profilenuCh5rk6YVMeta?.name ?? "projectId-profile___nl",
    path: profilenuCh5rk6YVMeta?.path ?? "/nl/:projectId()/profile",
    meta: profilenuCh5rk6YVMeta || {},
    alias: profilenuCh5rk6YVMeta?.alias || [],
    redirect: profilenuCh5rk6YVMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profilenuCh5rk6YVMeta?.name ?? "projectId-profile___de",
    path: profilenuCh5rk6YVMeta?.path ?? "/de/:projectId()/profile",
    meta: profilenuCh5rk6YVMeta || {},
    alias: profilenuCh5rk6YVMeta?.alias || [],
    redirect: profilenuCh5rk6YVMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profilenuCh5rk6YVMeta?.name ?? "projectId-profile___es",
    path: profilenuCh5rk6YVMeta?.path ?? "/es/:projectId()/profile",
    meta: profilenuCh5rk6YVMeta || {},
    alias: profilenuCh5rk6YVMeta?.alias || [],
    redirect: profilenuCh5rk6YVMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profilenuCh5rk6YVMeta?.name ?? "projectId-profile___fr",
    path: profilenuCh5rk6YVMeta?.path ?? "/fr/:projectId()/profile",
    meta: profilenuCh5rk6YVMeta || {},
    alias: profilenuCh5rk6YVMeta?.alias || [],
    redirect: profilenuCh5rk6YVMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: image6QgcEPZ3JyMeta?.name ?? "admin-answer-answerId-image___en",
    path: image6QgcEPZ3JyMeta?.path ?? "/admin/answer/:answerId()/image",
    meta: image6QgcEPZ3JyMeta || {},
    alias: image6QgcEPZ3JyMeta?.alias || [],
    redirect: image6QgcEPZ3JyMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/answer/[answerId]/image.vue").then(m => m.default || m)
  },
  {
    name: image6QgcEPZ3JyMeta?.name ?? "admin-answer-answerId-image___nl",
    path: image6QgcEPZ3JyMeta?.path ?? "/nl/admin/answer/:answerId()/image",
    meta: image6QgcEPZ3JyMeta || {},
    alias: image6QgcEPZ3JyMeta?.alias || [],
    redirect: image6QgcEPZ3JyMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/answer/[answerId]/image.vue").then(m => m.default || m)
  },
  {
    name: image6QgcEPZ3JyMeta?.name ?? "admin-answer-answerId-image___de",
    path: image6QgcEPZ3JyMeta?.path ?? "/de/admin/answer/:answerId()/image",
    meta: image6QgcEPZ3JyMeta || {},
    alias: image6QgcEPZ3JyMeta?.alias || [],
    redirect: image6QgcEPZ3JyMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/answer/[answerId]/image.vue").then(m => m.default || m)
  },
  {
    name: image6QgcEPZ3JyMeta?.name ?? "admin-answer-answerId-image___es",
    path: image6QgcEPZ3JyMeta?.path ?? "/es/admin/answer/:answerId()/image",
    meta: image6QgcEPZ3JyMeta || {},
    alias: image6QgcEPZ3JyMeta?.alias || [],
    redirect: image6QgcEPZ3JyMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/answer/[answerId]/image.vue").then(m => m.default || m)
  },
  {
    name: image6QgcEPZ3JyMeta?.name ?? "admin-answer-answerId-image___fr",
    path: image6QgcEPZ3JyMeta?.path ?? "/fr/admin/answer/:answerId()/image",
    meta: image6QgcEPZ3JyMeta || {},
    alias: image6QgcEPZ3JyMeta?.alias || [],
    redirect: image6QgcEPZ3JyMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/answer/[answerId]/image.vue").then(m => m.default || m)
  },
  {
    name: indexi2eBB2yaB7Meta?.name ?? "admin___en",
    path: indexi2eBB2yaB7Meta?.path ?? "/admin",
    meta: indexi2eBB2yaB7Meta || {},
    alias: indexi2eBB2yaB7Meta?.alias || [],
    redirect: indexi2eBB2yaB7Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: indexi2eBB2yaB7Meta?.name ?? "admin___nl",
    path: indexi2eBB2yaB7Meta?.path ?? "/nl/admin",
    meta: indexi2eBB2yaB7Meta || {},
    alias: indexi2eBB2yaB7Meta?.alias || [],
    redirect: indexi2eBB2yaB7Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: indexi2eBB2yaB7Meta?.name ?? "admin___de",
    path: indexi2eBB2yaB7Meta?.path ?? "/de/admin",
    meta: indexi2eBB2yaB7Meta || {},
    alias: indexi2eBB2yaB7Meta?.alias || [],
    redirect: indexi2eBB2yaB7Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: indexi2eBB2yaB7Meta?.name ?? "admin___es",
    path: indexi2eBB2yaB7Meta?.path ?? "/es/admin",
    meta: indexi2eBB2yaB7Meta || {},
    alias: indexi2eBB2yaB7Meta?.alias || [],
    redirect: indexi2eBB2yaB7Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: indexi2eBB2yaB7Meta?.name ?? "admin___fr",
    path: indexi2eBB2yaB7Meta?.path ?? "/fr/admin",
    meta: indexi2eBB2yaB7Meta || {},
    alias: indexi2eBB2yaB7Meta?.alias || [],
    redirect: indexi2eBB2yaB7Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: aggregategwzXh4m6deMeta?.name ?? "admin-project-projectId-aggregate___en",
    path: aggregategwzXh4m6deMeta?.path ?? "/admin/project/:projectId()/aggregate",
    meta: aggregategwzXh4m6deMeta || {},
    alias: aggregategwzXh4m6deMeta?.alias || [],
    redirect: aggregategwzXh4m6deMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/aggregate.vue").then(m => m.default || m)
  },
  {
    name: aggregategwzXh4m6deMeta?.name ?? "admin-project-projectId-aggregate___nl",
    path: aggregategwzXh4m6deMeta?.path ?? "/nl/admin/project/:projectId()/aggregate",
    meta: aggregategwzXh4m6deMeta || {},
    alias: aggregategwzXh4m6deMeta?.alias || [],
    redirect: aggregategwzXh4m6deMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/aggregate.vue").then(m => m.default || m)
  },
  {
    name: aggregategwzXh4m6deMeta?.name ?? "admin-project-projectId-aggregate___de",
    path: aggregategwzXh4m6deMeta?.path ?? "/de/admin/project/:projectId()/aggregate",
    meta: aggregategwzXh4m6deMeta || {},
    alias: aggregategwzXh4m6deMeta?.alias || [],
    redirect: aggregategwzXh4m6deMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/aggregate.vue").then(m => m.default || m)
  },
  {
    name: aggregategwzXh4m6deMeta?.name ?? "admin-project-projectId-aggregate___es",
    path: aggregategwzXh4m6deMeta?.path ?? "/es/admin/project/:projectId()/aggregate",
    meta: aggregategwzXh4m6deMeta || {},
    alias: aggregategwzXh4m6deMeta?.alias || [],
    redirect: aggregategwzXh4m6deMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/aggregate.vue").then(m => m.default || m)
  },
  {
    name: aggregategwzXh4m6deMeta?.name ?? "admin-project-projectId-aggregate___fr",
    path: aggregategwzXh4m6deMeta?.path ?? "/fr/admin/project/:projectId()/aggregate",
    meta: aggregategwzXh4m6deMeta || {},
    alias: aggregategwzXh4m6deMeta?.alias || [],
    redirect: aggregategwzXh4m6deMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/aggregate.vue").then(m => m.default || m)
  },
  {
    name: index0stiue8G9jMeta?.name ?? "admin-project-projectId___en",
    path: index0stiue8G9jMeta?.path ?? "/admin/project/:projectId()",
    meta: index0stiue8G9jMeta || {},
    alias: index0stiue8G9jMeta?.alias || [],
    redirect: index0stiue8G9jMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: index0stiue8G9jMeta?.name ?? "admin-project-projectId___nl",
    path: index0stiue8G9jMeta?.path ?? "/nl/admin/project/:projectId()",
    meta: index0stiue8G9jMeta || {},
    alias: index0stiue8G9jMeta?.alias || [],
    redirect: index0stiue8G9jMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: index0stiue8G9jMeta?.name ?? "admin-project-projectId___de",
    path: index0stiue8G9jMeta?.path ?? "/de/admin/project/:projectId()",
    meta: index0stiue8G9jMeta || {},
    alias: index0stiue8G9jMeta?.alias || [],
    redirect: index0stiue8G9jMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: index0stiue8G9jMeta?.name ?? "admin-project-projectId___es",
    path: index0stiue8G9jMeta?.path ?? "/es/admin/project/:projectId()",
    meta: index0stiue8G9jMeta || {},
    alias: index0stiue8G9jMeta?.alias || [],
    redirect: index0stiue8G9jMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: index0stiue8G9jMeta?.name ?? "admin-project-projectId___fr",
    path: index0stiue8G9jMeta?.path ?? "/fr/admin/project/:projectId()",
    meta: index0stiue8G9jMeta || {},
    alias: index0stiue8G9jMeta?.alias || [],
    redirect: index0stiue8G9jMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: profileal7ud3IryLMeta?.name ?? "admin-project-projectId-profile___en",
    path: profileal7ud3IryLMeta?.path ?? "/admin/project/:projectId()/profile",
    meta: profileal7ud3IryLMeta || {},
    alias: profileal7ud3IryLMeta?.alias || [],
    redirect: profileal7ud3IryLMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profileal7ud3IryLMeta?.name ?? "admin-project-projectId-profile___nl",
    path: profileal7ud3IryLMeta?.path ?? "/nl/admin/project/:projectId()/profile",
    meta: profileal7ud3IryLMeta || {},
    alias: profileal7ud3IryLMeta?.alias || [],
    redirect: profileal7ud3IryLMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profileal7ud3IryLMeta?.name ?? "admin-project-projectId-profile___de",
    path: profileal7ud3IryLMeta?.path ?? "/de/admin/project/:projectId()/profile",
    meta: profileal7ud3IryLMeta || {},
    alias: profileal7ud3IryLMeta?.alias || [],
    redirect: profileal7ud3IryLMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profileal7ud3IryLMeta?.name ?? "admin-project-projectId-profile___es",
    path: profileal7ud3IryLMeta?.path ?? "/es/admin/project/:projectId()/profile",
    meta: profileal7ud3IryLMeta || {},
    alias: profileal7ud3IryLMeta?.alias || [],
    redirect: profileal7ud3IryLMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profileal7ud3IryLMeta?.name ?? "admin-project-projectId-profile___fr",
    path: profileal7ud3IryLMeta?.path ?? "/fr/admin/project/:projectId()/profile",
    meta: profileal7ud3IryLMeta || {},
    alias: profileal7ud3IryLMeta?.alias || [],
    redirect: profileal7ud3IryLMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: resultsKLBisWWskGMeta?.name ?? "admin-project-projectId-results___en",
    path: resultsKLBisWWskGMeta?.path ?? "/admin/project/:projectId()/results",
    meta: resultsKLBisWWskGMeta || {},
    alias: resultsKLBisWWskGMeta?.alias || [],
    redirect: resultsKLBisWWskGMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsKLBisWWskGMeta?.name ?? "admin-project-projectId-results___nl",
    path: resultsKLBisWWskGMeta?.path ?? "/nl/admin/project/:projectId()/results",
    meta: resultsKLBisWWskGMeta || {},
    alias: resultsKLBisWWskGMeta?.alias || [],
    redirect: resultsKLBisWWskGMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsKLBisWWskGMeta?.name ?? "admin-project-projectId-results___de",
    path: resultsKLBisWWskGMeta?.path ?? "/de/admin/project/:projectId()/results",
    meta: resultsKLBisWWskGMeta || {},
    alias: resultsKLBisWWskGMeta?.alias || [],
    redirect: resultsKLBisWWskGMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsKLBisWWskGMeta?.name ?? "admin-project-projectId-results___es",
    path: resultsKLBisWWskGMeta?.path ?? "/es/admin/project/:projectId()/results",
    meta: resultsKLBisWWskGMeta || {},
    alias: resultsKLBisWWskGMeta?.alias || [],
    redirect: resultsKLBisWWskGMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsKLBisWWskGMeta?.name ?? "admin-project-projectId-results___fr",
    path: resultsKLBisWWskGMeta?.path ?? "/fr/admin/project/:projectId()/results",
    meta: resultsKLBisWWskGMeta || {},
    alias: resultsKLBisWWskGMeta?.alias || [],
    redirect: resultsKLBisWWskGMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/results.vue").then(m => m.default || m)
  },
  {
    name: _91roundId_93ybsjBIdtELMeta?.name ?? "admin-project-projectId-round-roundId___en",
    path: _91roundId_93ybsjBIdtELMeta?.path ?? "/admin/project/:projectId()/round/:roundId()",
    meta: _91roundId_93ybsjBIdtELMeta || {},
    alias: _91roundId_93ybsjBIdtELMeta?.alias || [],
    redirect: _91roundId_93ybsjBIdtELMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/round/[roundId].vue").then(m => m.default || m)
  },
  {
    name: _91roundId_93ybsjBIdtELMeta?.name ?? "admin-project-projectId-round-roundId___nl",
    path: _91roundId_93ybsjBIdtELMeta?.path ?? "/nl/admin/project/:projectId()/round/:roundId()",
    meta: _91roundId_93ybsjBIdtELMeta || {},
    alias: _91roundId_93ybsjBIdtELMeta?.alias || [],
    redirect: _91roundId_93ybsjBIdtELMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/round/[roundId].vue").then(m => m.default || m)
  },
  {
    name: _91roundId_93ybsjBIdtELMeta?.name ?? "admin-project-projectId-round-roundId___de",
    path: _91roundId_93ybsjBIdtELMeta?.path ?? "/de/admin/project/:projectId()/round/:roundId()",
    meta: _91roundId_93ybsjBIdtELMeta || {},
    alias: _91roundId_93ybsjBIdtELMeta?.alias || [],
    redirect: _91roundId_93ybsjBIdtELMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/round/[roundId].vue").then(m => m.default || m)
  },
  {
    name: _91roundId_93ybsjBIdtELMeta?.name ?? "admin-project-projectId-round-roundId___es",
    path: _91roundId_93ybsjBIdtELMeta?.path ?? "/es/admin/project/:projectId()/round/:roundId()",
    meta: _91roundId_93ybsjBIdtELMeta || {},
    alias: _91roundId_93ybsjBIdtELMeta?.alias || [],
    redirect: _91roundId_93ybsjBIdtELMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/round/[roundId].vue").then(m => m.default || m)
  },
  {
    name: _91roundId_93ybsjBIdtELMeta?.name ?? "admin-project-projectId-round-roundId___fr",
    path: _91roundId_93ybsjBIdtELMeta?.path ?? "/fr/admin/project/:projectId()/round/:roundId()",
    meta: _91roundId_93ybsjBIdtELMeta || {},
    alias: _91roundId_93ybsjBIdtELMeta?.alias || [],
    redirect: _91roundId_93ybsjBIdtELMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/round/[roundId].vue").then(m => m.default || m)
  },
  {
    name: createrbaGHcl6MVMeta?.name ?? "admin-project-projectId-round-create___en",
    path: createrbaGHcl6MVMeta?.path ?? "/admin/project/:projectId()/round/create",
    meta: createrbaGHcl6MVMeta || {},
    alias: createrbaGHcl6MVMeta?.alias || [],
    redirect: createrbaGHcl6MVMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/round/create.vue").then(m => m.default || m)
  },
  {
    name: createrbaGHcl6MVMeta?.name ?? "admin-project-projectId-round-create___nl",
    path: createrbaGHcl6MVMeta?.path ?? "/nl/admin/project/:projectId()/round/create",
    meta: createrbaGHcl6MVMeta || {},
    alias: createrbaGHcl6MVMeta?.alias || [],
    redirect: createrbaGHcl6MVMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/round/create.vue").then(m => m.default || m)
  },
  {
    name: createrbaGHcl6MVMeta?.name ?? "admin-project-projectId-round-create___de",
    path: createrbaGHcl6MVMeta?.path ?? "/de/admin/project/:projectId()/round/create",
    meta: createrbaGHcl6MVMeta || {},
    alias: createrbaGHcl6MVMeta?.alias || [],
    redirect: createrbaGHcl6MVMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/round/create.vue").then(m => m.default || m)
  },
  {
    name: createrbaGHcl6MVMeta?.name ?? "admin-project-projectId-round-create___es",
    path: createrbaGHcl6MVMeta?.path ?? "/es/admin/project/:projectId()/round/create",
    meta: createrbaGHcl6MVMeta || {},
    alias: createrbaGHcl6MVMeta?.alias || [],
    redirect: createrbaGHcl6MVMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/round/create.vue").then(m => m.default || m)
  },
  {
    name: createrbaGHcl6MVMeta?.name ?? "admin-project-projectId-round-create___fr",
    path: createrbaGHcl6MVMeta?.path ?? "/fr/admin/project/:projectId()/round/create",
    meta: createrbaGHcl6MVMeta || {},
    alias: createrbaGHcl6MVMeta?.alias || [],
    redirect: createrbaGHcl6MVMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/round/create.vue").then(m => m.default || m)
  },
  {
    name: _91userId_9302iBLFUqudMeta?.name ?? "admin-project-projectId-users-userId___en",
    path: _91userId_9302iBLFUqudMeta?.path ?? "/admin/project/:projectId()/users/:userId()",
    meta: _91userId_9302iBLFUqudMeta || {},
    alias: _91userId_9302iBLFUqudMeta?.alias || [],
    redirect: _91userId_9302iBLFUqudMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/users/[userId].vue").then(m => m.default || m)
  },
  {
    name: _91userId_9302iBLFUqudMeta?.name ?? "admin-project-projectId-users-userId___nl",
    path: _91userId_9302iBLFUqudMeta?.path ?? "/nl/admin/project/:projectId()/users/:userId()",
    meta: _91userId_9302iBLFUqudMeta || {},
    alias: _91userId_9302iBLFUqudMeta?.alias || [],
    redirect: _91userId_9302iBLFUqudMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/users/[userId].vue").then(m => m.default || m)
  },
  {
    name: _91userId_9302iBLFUqudMeta?.name ?? "admin-project-projectId-users-userId___de",
    path: _91userId_9302iBLFUqudMeta?.path ?? "/de/admin/project/:projectId()/users/:userId()",
    meta: _91userId_9302iBLFUqudMeta || {},
    alias: _91userId_9302iBLFUqudMeta?.alias || [],
    redirect: _91userId_9302iBLFUqudMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/users/[userId].vue").then(m => m.default || m)
  },
  {
    name: _91userId_9302iBLFUqudMeta?.name ?? "admin-project-projectId-users-userId___es",
    path: _91userId_9302iBLFUqudMeta?.path ?? "/es/admin/project/:projectId()/users/:userId()",
    meta: _91userId_9302iBLFUqudMeta || {},
    alias: _91userId_9302iBLFUqudMeta?.alias || [],
    redirect: _91userId_9302iBLFUqudMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/users/[userId].vue").then(m => m.default || m)
  },
  {
    name: _91userId_9302iBLFUqudMeta?.name ?? "admin-project-projectId-users-userId___fr",
    path: _91userId_9302iBLFUqudMeta?.path ?? "/fr/admin/project/:projectId()/users/:userId()",
    meta: _91userId_9302iBLFUqudMeta || {},
    alias: _91userId_9302iBLFUqudMeta?.alias || [],
    redirect: _91userId_9302iBLFUqudMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/users/[userId].vue").then(m => m.default || m)
  },
  {
    name: indexmkn98puJ23Meta?.name ?? "admin-project-projectId-users___en",
    path: indexmkn98puJ23Meta?.path ?? "/admin/project/:projectId()/users",
    meta: indexmkn98puJ23Meta || {},
    alias: indexmkn98puJ23Meta?.alias || [],
    redirect: indexmkn98puJ23Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/users/index.vue").then(m => m.default || m)
  },
  {
    name: indexmkn98puJ23Meta?.name ?? "admin-project-projectId-users___nl",
    path: indexmkn98puJ23Meta?.path ?? "/nl/admin/project/:projectId()/users",
    meta: indexmkn98puJ23Meta || {},
    alias: indexmkn98puJ23Meta?.alias || [],
    redirect: indexmkn98puJ23Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/users/index.vue").then(m => m.default || m)
  },
  {
    name: indexmkn98puJ23Meta?.name ?? "admin-project-projectId-users___de",
    path: indexmkn98puJ23Meta?.path ?? "/de/admin/project/:projectId()/users",
    meta: indexmkn98puJ23Meta || {},
    alias: indexmkn98puJ23Meta?.alias || [],
    redirect: indexmkn98puJ23Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/users/index.vue").then(m => m.default || m)
  },
  {
    name: indexmkn98puJ23Meta?.name ?? "admin-project-projectId-users___es",
    path: indexmkn98puJ23Meta?.path ?? "/es/admin/project/:projectId()/users",
    meta: indexmkn98puJ23Meta || {},
    alias: indexmkn98puJ23Meta?.alias || [],
    redirect: indexmkn98puJ23Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/users/index.vue").then(m => m.default || m)
  },
  {
    name: indexmkn98puJ23Meta?.name ?? "admin-project-projectId-users___fr",
    path: indexmkn98puJ23Meta?.path ?? "/fr/admin/project/:projectId()/users",
    meta: indexmkn98puJ23Meta || {},
    alias: indexmkn98puJ23Meta?.alias || [],
    redirect: indexmkn98puJ23Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/[projectId]/users/index.vue").then(m => m.default || m)
  },
  {
    name: createMrEiG166E8Meta?.name ?? "admin-project-create___en",
    path: createMrEiG166E8Meta?.path ?? "/admin/project/create",
    meta: createMrEiG166E8Meta || {},
    alias: createMrEiG166E8Meta?.alias || [],
    redirect: createMrEiG166E8Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/create.vue").then(m => m.default || m)
  },
  {
    name: createMrEiG166E8Meta?.name ?? "admin-project-create___nl",
    path: createMrEiG166E8Meta?.path ?? "/nl/admin/project/create",
    meta: createMrEiG166E8Meta || {},
    alias: createMrEiG166E8Meta?.alias || [],
    redirect: createMrEiG166E8Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/create.vue").then(m => m.default || m)
  },
  {
    name: createMrEiG166E8Meta?.name ?? "admin-project-create___de",
    path: createMrEiG166E8Meta?.path ?? "/de/admin/project/create",
    meta: createMrEiG166E8Meta || {},
    alias: createMrEiG166E8Meta?.alias || [],
    redirect: createMrEiG166E8Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/create.vue").then(m => m.default || m)
  },
  {
    name: createMrEiG166E8Meta?.name ?? "admin-project-create___es",
    path: createMrEiG166E8Meta?.path ?? "/es/admin/project/create",
    meta: createMrEiG166E8Meta || {},
    alias: createMrEiG166E8Meta?.alias || [],
    redirect: createMrEiG166E8Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/create.vue").then(m => m.default || m)
  },
  {
    name: createMrEiG166E8Meta?.name ?? "admin-project-create___fr",
    path: createMrEiG166E8Meta?.path ?? "/fr/admin/project/create",
    meta: createMrEiG166E8Meta || {},
    alias: createMrEiG166E8Meta?.alias || [],
    redirect: createMrEiG166E8Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/admin/project/create.vue").then(m => m.default || m)
  },
  {
    name: indexXYhPSjsEQoMeta?.name ?? "index___en",
    path: indexXYhPSjsEQoMeta?.path ?? "/",
    meta: indexXYhPSjsEQoMeta || {},
    alias: indexXYhPSjsEQoMeta?.alias || [],
    redirect: indexXYhPSjsEQoMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexXYhPSjsEQoMeta?.name ?? "index___nl",
    path: indexXYhPSjsEQoMeta?.path ?? "/nl",
    meta: indexXYhPSjsEQoMeta || {},
    alias: indexXYhPSjsEQoMeta?.alias || [],
    redirect: indexXYhPSjsEQoMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexXYhPSjsEQoMeta?.name ?? "index___de",
    path: indexXYhPSjsEQoMeta?.path ?? "/de",
    meta: indexXYhPSjsEQoMeta || {},
    alias: indexXYhPSjsEQoMeta?.alias || [],
    redirect: indexXYhPSjsEQoMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexXYhPSjsEQoMeta?.name ?? "index___es",
    path: indexXYhPSjsEQoMeta?.path ?? "/es",
    meta: indexXYhPSjsEQoMeta || {},
    alias: indexXYhPSjsEQoMeta?.alias || [],
    redirect: indexXYhPSjsEQoMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexXYhPSjsEQoMeta?.name ?? "index___fr",
    path: indexXYhPSjsEQoMeta?.path ?? "/fr",
    meta: indexXYhPSjsEQoMeta || {},
    alias: indexXYhPSjsEQoMeta?.alias || [],
    redirect: indexXYhPSjsEQoMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: loginoWvDcAgGkjMeta?.name ?? "login___en",
    path: loginoWvDcAgGkjMeta?.path ?? "/login",
    meta: loginoWvDcAgGkjMeta || {},
    alias: loginoWvDcAgGkjMeta?.alias || [],
    redirect: loginoWvDcAgGkjMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginoWvDcAgGkjMeta?.name ?? "login___nl",
    path: loginoWvDcAgGkjMeta?.path ?? "/nl/login",
    meta: loginoWvDcAgGkjMeta || {},
    alias: loginoWvDcAgGkjMeta?.alias || [],
    redirect: loginoWvDcAgGkjMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginoWvDcAgGkjMeta?.name ?? "login___de",
    path: loginoWvDcAgGkjMeta?.path ?? "/de/login",
    meta: loginoWvDcAgGkjMeta || {},
    alias: loginoWvDcAgGkjMeta?.alias || [],
    redirect: loginoWvDcAgGkjMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginoWvDcAgGkjMeta?.name ?? "login___es",
    path: loginoWvDcAgGkjMeta?.path ?? "/es/login",
    meta: loginoWvDcAgGkjMeta || {},
    alias: loginoWvDcAgGkjMeta?.alias || [],
    redirect: loginoWvDcAgGkjMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginoWvDcAgGkjMeta?.name ?? "login___fr",
    path: loginoWvDcAgGkjMeta?.path ?? "/fr/login",
    meta: loginoWvDcAgGkjMeta || {},
    alias: loginoWvDcAgGkjMeta?.alias || [],
    redirect: loginoWvDcAgGkjMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: registerEgeCKsRer8Meta?.name ?? "register___en",
    path: registerEgeCKsRer8Meta?.path ?? "/register",
    meta: registerEgeCKsRer8Meta || {},
    alias: registerEgeCKsRer8Meta?.alias || [],
    redirect: registerEgeCKsRer8Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registerEgeCKsRer8Meta?.name ?? "register___nl",
    path: registerEgeCKsRer8Meta?.path ?? "/nl/register",
    meta: registerEgeCKsRer8Meta || {},
    alias: registerEgeCKsRer8Meta?.alias || [],
    redirect: registerEgeCKsRer8Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registerEgeCKsRer8Meta?.name ?? "register___de",
    path: registerEgeCKsRer8Meta?.path ?? "/de/register",
    meta: registerEgeCKsRer8Meta || {},
    alias: registerEgeCKsRer8Meta?.alias || [],
    redirect: registerEgeCKsRer8Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registerEgeCKsRer8Meta?.name ?? "register___es",
    path: registerEgeCKsRer8Meta?.path ?? "/es/register",
    meta: registerEgeCKsRer8Meta || {},
    alias: registerEgeCKsRer8Meta?.alias || [],
    redirect: registerEgeCKsRer8Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registerEgeCKsRer8Meta?.name ?? "register___fr",
    path: registerEgeCKsRer8Meta?.path ?? "/fr/register",
    meta: registerEgeCKsRer8Meta || {},
    alias: registerEgeCKsRer8Meta?.alias || [],
    redirect: registerEgeCKsRer8Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src3411422935/src/sense-us.app/pages/register.vue").then(m => m.default || m)
  }
]